import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ComplaintForm } from '../ComplaintForm'
import { multilineTextPage } from '../../pages'
import { withDocTitle } from '../../components/withDocTitle'
import { processFeedback } from '../../utilities/methods/apiHelperMethods'
import { feedback } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import css from '../ComplaintForm/ComplaintForm.module.css'

export class FeedbackForm extends React.Component {
  backLink = (
    <Button
      variation="transparent"
      size="small"
      onClick={() => this.props.history.goBack()}
    >
      <FontAwesomeIcon icon="angle-left" className="ds-u-margin-right--1" />
      Back
    </Button>
  )

  hint =
    'We have launched our new complaint forms, and would appreciate your feedback. Please tell us about your experience and provide any recommendations on how we can improve the website. Thank you for taking the time to help us improve our complaint process.'

  schema = {
    onSubmit: formValues => this.handleFeedback(formValues),
    pages: [
      multilineTextPage({
        pageId: 'feedback_page',
        fieldName: 'message',
        label: 'Your feedback helps us improve',
        labelClassName: css.largeLabel,
        hint: this.hint,
        rows: 8
      })
    ]
  }

  successURL = routes.feedback.confirmation

  handleFeedback = formValues => {
    processFeedback(formValues, this.props.history, this.successURL)
  }

  render() {
    return <ComplaintForm schema={this.schema} headerContent={this.backLink} />
  }
}

export default withDocTitle(FeedbackForm, feedback)
